const main = (resolve) => require(['@/views/index/index.vue'], resolve) // 主页

const transactionLog = (resolve) =>
  require(['@/views/transactionManagement/transactionLog'], resolve) // 交易查询

const refundLog = (resolve) =>
  require(['@/views/transactionManagement/refundLog'], resolve) // 交易查询

export default [
  {
    path: '/index',
    component: main,
    children: [
      // 交易查询
      {
        name: 'TransactionLog',
        path: '/aq/transitionLog',
        alias: ['/aq/transitionLog.htm'],
        component: transactionLog
      },
      // 退款查询
      {
        name: 'RefundLog',
        path: '/aq/refundLog',
        alias: ['/aq/refundLog.htm'],
        component: refundLog
      }
    ]
  }
]
